import { Box, Typography, Button } from '@mui/material';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import { styles } from './styles';

const DashboardHeader = ({ isTripDashboardVisible }) => {
    console.log("sf", isTripDashboardVisible);

    return (
        <Box sx={{ ...styles.header, position: 'relative' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 2 }}>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                        sx={{
                            fontWeight: 800,
                            width: '100%',
                            display: 'flex',
                            fontSize: 'clamp(18px, 2.8vw, 36px)',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            justifyContent: 'center',
                        }}
                    >
                        Delhi Jal Board · Water Tanker Management
                    </Typography>
                </Box>

                {isTripDashboardVisible && (
                    <Button
                        variant="contained"
                        startIcon={<DirectionsBusIcon />}
                        onClick={() => window.open('/tripslist', '_blank')}
                        sx={{
                            position: 'absolute',
                            right: 16,
                            backgroundColor: '#1a90ff',
                            color: '#fff',
                            textTransform: 'none',
                            fontWeight: 600,
                            borderRadius: '8px',
                            px: 2.5,
                            whiteSpace: 'nowrap',
                            flexShrink: 0,
                            '&:hover': { backgroundColor: '#1179d4' },
                        }}
                    >
                        Trip Dashboard
                    </Button>
                )}
            </Box>
        </Box>
    );
};

export default DashboardHeader;